module.exports = __webpack_public_path__ + "3031b683bafcd9ded070c00d784f4626.woff2";